import React from 'react';
import { Helmet } from 'react-helmet-async';
import Blog, { blogPosts } from '../components/Blog';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://wayug.com/' },
    { '@type': 'ListItem', position: 2, name: 'Blog', item: 'https://wayug.com/blog' },
  ],
};

const itemListSchema = {
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  name: 'Wayug Infotech Solutions Engineering Blog',
  description: 'Technical insights, compliance checklists, AI ROI models, and cost optimization case studies from India\'s premier enterprise IT specialists.',
  url: 'https://wayug.com/blog',
  numberOfItems: blogPosts.length,
  itemListElement: blogPosts.map((post, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    url: `https://wayug.com/blog/${post.slug}`,
    name: post.title,
  })),
};

const BlogPage = () => {
  return (
    <div className="page-content subpage-content">
      <Helmet>
        {/* ── SEO Title & Description ── */}
        <title>Enterprise IT Insights, Checklists &amp; Guides | Wayug Blog</title>
        <meta
          name="description"
          content="Deepen your knowledge with technical cloud migration checklists, Zero-Trust compliance plans, AI ROI calculators, and AWS infrastructure case studies from Wayug Infotech."
        />
        <link rel="canonical" href="https://wayug.com/blog" />

        {/* ── Open Graph ── */}
        <meta property="og:title" content="Enterprise IT Insights, Checklists &amp; Guides | Wayug Blog" />
        <meta
          property="og:description"
          content="Gain technical foresight from senior cloud engineers and security analysts. Read checklists, AI guides, HIPAA roadmaps, and Kubernetes case studies."
        />
        <meta property="og:url" content="https://wayug.com/blog" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://wayug.com/logofull.png" />

        {/* ── Structured Schemas ── */}
        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(itemListSchema)}</script>
      </Helmet>
      
      <Blog />
    </div>
  );
};

export default BlogPage;
